// extracted by mini-css-extract-plugin
export default {"discountIconWrapper":"DiscountFooter-module__discountIconWrapper___37o9B"};